var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600.05 600.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff4a4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_82",
    "data-name": "Layer 82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599,181.63C589.78,76.31,519,0,430.29,0c-51,0-98.86,26.86-130.24,70.93C268.66,26.86,220.71.6,169.76.6,81.1.6,10.27,76.91,1,182.23c-1,6.9-3.3,31.32,5.16,69.43,20.91,93.62,95.16,159.2,161.46,222.53L300,600.6s0-9,0-24.7c0,15.3,0,24.1,0,24.1q66.18-63.21,132.33-126.41c66.31-63.33,140.56-128.91,161.47-222.53C602.31,213,600,188.53,599,181.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.7574600cceadaf00639588357e8a2c09.svg";
export { ForwardRef as ReactComponent };